import { ChangeTaskOpt } from './profile-constant';
import { State } from '@/store/modules/apm/profile/profile.store';

const getters = {
  updateTaskOpt() {
    return ChangeTaskOpt;
  },
  taskListGetter(state: State) {
    if (!state.taskListSource.length) {
      return [];
    }

    return state.taskListSource;
  },
  segmentListGetter(state: State) {
    return state.segmentList;
  }
};

export default getters;
